<div class="card">
  <div class="card-header-panel">
    <h4>Zuletzt auf OTC-X gehandelt</h4>
  </div>

  <otcx-error-or-loading [errorWrapper]="isTradingDayLoader">
    @if (!!tradesLoader) {
      <otcx-error-or-loading [errorWrapper]="tradesLoader">
        @if (isTradingDayLoader.data$ | async; as isTradingDay) {
          @if (isTradingDay && tradesLoader.data$ | async; as trades) {
            @if (!tradesLoader.hasEmptyData) {
              <div class="card-body-table">
                <table>
                  <tr>
                    <th>Titel</th>
                    <th class="align-right">Kurs</th>
                    <th class="align-right">Volumen</th>
                  </tr>
                  @for (trade of trades; track trade) {
                    <tr [ngClass]="{'trades-off-book-tr' : trade.offBook}">
                      <td><a [routerLink]="['/security', trade.isin]">{{trade.name}}</a></td>
                      <td class="align-right">{{trade.price | number:".2-2"}}</td>
                      <td class="align-right">
                        @if (trade.offBook) {
                          <small>Off Book</small>
                        }
                        <div>{{trade.volume| number:".0-0"}}</div>
                      </td>
                    </tr>
                  }
                </table>
              </div>
            }
            @if (tradesLoader.hasEmptyData) {
              <div class="card-body-no-data">
                Heute gab es noch keine Abschlüsse
              </div>
            }
          }
        } @else {
          <div class="card-body-no-data">
            Heute ist kein Handelstag
          </div>
        }
        <div class="card-footer-table-link">
          <a class="link-icon-text" [routerLink]="['trades']" data-test="trades-link">
            <span class="library-bekb-icon-font icon-link-intern"></span>
            <span>Abschlüsse der letzten drei Handelstage</span>
          </a>
        </div>
      </otcx-error-or-loading>
    }
  </otcx-error-or-loading>
</div>
